// RSVP Form Builder Functions
let rsvpQuestionCounter = 1;
let rsvpQuestions = [];
let customQuestionCounter = 0;

// Make rsvpQuestions globally accessible and keep it synced
window.rsvpQuestions = rsvpQuestions;

// Function to sync local and global arrays
function syncRSVPQuestions() {
    window.rsvpQuestions.length = 0;
    window.rsvpQuestions.push(...rsvpQuestions);
}

window.initializeRSVPFormBuilder = function initializeRSVPFormBuilder() {
    // Initialize RSVP toggle functionality
    initializeRSVPToggle();
    
    // Initialize custom questions functionality
    initializeCustomQuestions();

    // Fix sticky positioning by managing overflow
    initializeRSVPStickyFix();
    
    // Initialize sortable functionality when RSVP tab is first created
    document.addEventListener('click', function(e) {
        if (e.target.closest('[data-feature="rsvp"]') || e.target.closest('[data-target-model="rsvp-tab"]')) {
            setTimeout(() => {
                initializeSortable();
                loadRSVPFormData(); // Load data when RSVP tab is opened
                initializeGuestCountControls(); // Initialize guest count buttons
                initializeRSVPToggle();
                initializeCustomQuestions();
                initializeRSVPStickyFix();
            }, 100);
        }
    });
}

// Function to fix sticky positioning inside accordion by managing overflow
function initializeRSVPStickyFix() {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-toggle-state') {
                const card = mutation.target;
                const state = card.getAttribute('data-toggle-state');
                const contentInner = card.querySelector('.content-inner');
                
                if (!contentInner) return;

                if (state === 'open') {
                    // Wait for animation to finish then allow overflow
                    // Transition is 0.5s, so we wait slightly longer
                    setTimeout(() => {
                        // Double check state is still open
                        if (card.getAttribute('data-toggle-state') === 'open') {
                             contentInner.style.overflow = 'visible';
                        }
                    }, 550); 
                } else {
                    // Reset immediately for closing animation to work
                    contentInner.style.overflow = 'hidden';
                }
            }
        });
    });

    document.querySelectorAll('.collapsible-card, .open-edit-card').forEach(card => {
        // Only attach if not already observing (tracking via attribute or just rely on idempotent behavior if implementation allows, 
        // but MutationObserver.observe on same target is additive? No, it replaces if same options?)
        // Actually, let's just observe. If called multiple times, it might duplicate callbacks if new observer.
        // So we should check.
        if (card.dataset.stickyObserverAttached) return;
        
        observer.observe(card, { attributes: true });
        card.dataset.stickyObserverAttached = 'true';
        
        // Initial check for already open cards
        if (card.getAttribute('data-toggle-state') === 'open' || card.classList.contains('open-edit-card')) {
            const contentInner = card.querySelector('.content-inner');
            if (contentInner) {
                 // If it's an open-edit-card (always open) or already open collapsible
                 contentInner.style.overflow = 'visible';
            }
        }
    });
}

function setupCustomQuestionsDragAndDrop() {
    const container = document.getElementById('customQuestionsContainer');
    if (!container) return;

    let draggedItem = null;
    let touchStartY = 0;
    
    // Desktop Drag Events
    container.addEventListener('dragstart', function(e) {
        draggedItem = e.target.closest('.custom-question-item');
        if (draggedItem) {
            draggedItem.classList.add('sortable-drag'); 
            draggedItem.style.opacity = '0.5';
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('text/plain', draggedItem.dataset.questionId);
        }
    });

    container.addEventListener('dragend', function(e) {
         if (draggedItem) {
            draggedItem.classList.remove('sortable-drag');
            draggedItem.style.opacity = '1';
            draggedItem = null;
            saveCustomQuestions();
         }
    });

    container.addEventListener('dragover', function(e) {
        e.preventDefault();
        const afterElement = getDragAfterElement(container, e.clientY);
        const currentDraggable = document.querySelector('.sortable-drag');
        if (!currentDraggable) return;

        if (afterElement == null) {
            container.appendChild(currentDraggable);
        } else {
            container.insertBefore(currentDraggable, afterElement);
        }
    });

    // Mobile Touch Events
    container.addEventListener('touchstart', function(e) {
        const handle = e.target.closest('.cursor-move');
        if (!handle) return; // Only allow dragging from the handle
        
        e.preventDefault(); // Prevent scrolling when dragging via handle
        const item = handle.closest('.custom-question-item');
        if (item) {
            draggedItem = item;
            draggedItem.classList.add('sortable-drag');
            draggedItem.style.opacity = '0.5';
            touchStartY = e.touches[0].clientY;
        }
    }, { passive: false });

    container.addEventListener('touchmove', function(e) {
        if (!draggedItem) return;
        e.preventDefault(); // Stop scrolling
        
        const currentY = e.touches[0].clientY;
        const afterElement = getDragAfterElement(container, currentY);
        
        if (afterElement == null) {
            container.appendChild(draggedItem);
        } else {
            container.insertBefore(draggedItem, afterElement);
        }
    }, { passive: false });

    container.addEventListener('touchend', function(e) {
        if (draggedItem) {
            draggedItem.classList.remove('sortable-drag');
            draggedItem.style.opacity = '1';
            draggedItem = null;
            saveCustomQuestions();
        }
    });
}

function updateCustomQuestionCount() {
    const container = document.getElementById('customQuestionsContainer');
    const badge = document.getElementById('customQuestionCount');
    if (!container || !badge) return;

    const count = container.querySelectorAll('.custom-question-item').length;
    badge.textContent = count;
    
    if (count > 0) {
        badge.style.display = 'block';
    } else {
        badge.style.display = 'none';
    }
}


function getDragAfterElement(container, y) {
    const draggableElements = [...container.querySelectorAll('.custom-question-item:not(.sortable-drag)')];

    return draggableElements.reduce((closest, child) => {
        const box = child.getBoundingClientRect();
        const offset = y - box.top - box.height / 2;
        if (offset < 0 && offset > closest.offset) {
            return { offset: offset, element: child };
        } else {
            return closest;
        }
    }, { offset: Number.NEGATIVE_INFINITY }).element;
}


// Initialize RSVP toggle
function initializeRSVPToggle() {
    const enableRSVPCheckbox = document.getElementById('enableRSVP');
    const rsvpFormContent = document.getElementById('rsvpFormContent');
    
    if (!enableRSVPCheckbox || !rsvpFormContent) return;
    
    enableRSVPCheckbox.addEventListener('change', function() {
        if (this.checked) {
            rsvpFormContent.classList.remove('disabled');
        } else {
            rsvpFormContent.classList.add('disabled');
        }
        saveRSVPFormData();
    });
    
    // Attach change listeners to all RSVP form fields
    attachRSVPFormListeners();
}

// Initialize custom questions functionality
function initializeCustomQuestions() {
    const addQuestionBtn = document.getElementById('addCustomQuestion');
    const questionsContainer = document.getElementById('customQuestionsContainer');
    
    if (!addQuestionBtn || !questionsContainer) return;
    
    // Remove existing listener if any
    const newBtn = addQuestionBtn.cloneNode(true);
    addQuestionBtn.parentNode.replaceChild(newBtn, addQuestionBtn);
    
    newBtn.addEventListener('click', function() {
        addCustomQuestion();
    });
    
    // Load saved custom questions
    loadCustomQuestions();

    // Initialize drag and drop for custom questions
    setupCustomQuestionsDragAndDrop();
}

// Add custom question
function addCustomQuestion(questionData = null) {
    const container = document.getElementById('customQuestionsContainer');
    if (!container) return;
    
    customQuestionCounter++;
    const questionId = questionData?.id || `custom_q_${customQuestionCounter}`;
    const questionType = questionData?.type || 'text';
    const questionText = questionData?.question || '';
    const isRequired = questionData?.required || false;
    const options = questionData?.options || [];
    
    const questionHTML = `
        <div class="custom-question-item minimal-card" data-question-id="${questionId}" draggable="true">
            <div class="row align-items-start mb-2">
                <div class="col">
                    <div class="form-group">
                        <select class="form-select form-select-sm border-0 bg-light d-inline-block py-1 ps-2 pe-4 question-type-select text-muted" 
                                style="font-size: 0.8rem;"
                                data-question-id="${questionId}" onchange="handleQuestionTypeChange(this)">
                            <option value="text" ${questionType === 'text' ? 'selected' : ''}>Short Text</option>
                            <option value="textarea" ${questionType === 'textarea' ? 'selected' : ''}>Long Text</option>
                            <option value="single" ${questionType === 'single' ? 'selected' : ''}>Single Choice</option>
                            <option value="multiple" ${questionType === 'multiple' ? 'selected' : ''}>Multiple Choice</option>
                            <option value="yesno" ${questionType === 'yesno' ? 'selected' : ''}>Yes/No</option>
                        </select>
                    </div>
                </div>
                <div class="col-auto">
                    <button type="button" class="btn btn-sm btn-link text-danger p-0 border-0" onclick="removeCustomQuestion('${questionId}')">
                        <i class="bi bi-trash"></i>
                    </button>
                </div>
            </div>
            
            <div class="question-body">
                <div class="form-group mb-2">
                    <input type="text" class="form-control form-control-flush question-text-input mb-1" 
                        data-question-id="${questionId}"
                        placeholder="Type your question" 
                        value="${questionText}"
                        onchange="saveCustomQuestions()" required>
                </div>

                ${(questionType === 'single' || questionType === 'multiple') ? `
                <div class="question-options ps-3 border-start border-2 border-light mb-2">
                    <label class="form-label small text-muted text-uppercase fw-bold" style="font-size:0.7rem; letter-spacing: 0.5px;">Options</label>
                    <div class="options-list" data-question-id="${questionId}">
                        ${options.length > 0 ? options.map((opt, idx) => `
                            <div class="option-item mb-2">
                                <div class="input-group input-group-sm">
                                    <input type="text" class="form-control bg-light border-0 rounded-1 option-input" 
                                           placeholder="Option ${idx + 1}" 
                                           value="${opt}"
                                           onchange="saveCustomQuestions()" required>
                                    <button type="button" class="btn btn-link text-danger text-decoration-none border-0" 
                                            onclick="removeOption(this)">
                                        <i class="bi bi-x-lg"></i>
                                    </button>
                                </div>
                            </div>
                        `).join('') : `
                            <div class="option-item mb-2">
                                <div class="input-group input-group-sm">
                                    <input type="text" class="form-control bg-light border-0 rounded-1 option-input" 
                                           placeholder="Option 1" 
                                           onchange="saveCustomQuestions()" required>
                                    <button type="button" class="btn btn-link text-danger text-decoration-none border-0" 
                                            onclick="removeOption(this)">
                                        <i class="bi bi-x-lg"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="option-item mb-2">
                                <div class="input-group input-group-sm">
                                    <input type="text" class="form-control bg-light border-0 rounded-1 option-input" 
                                           placeholder="Option 2" 
                                           onchange="saveCustomQuestions()" required>
                                    <button type="button" class="btn btn-link text-danger text-decoration-none border-0" 
                                            onclick="removeOption(this)">
                                        <i class="bi bi-x-lg"></i>
                                    </button>
                                </div>
                            </div>
                        `}
                    </div>
                    <button type="button" class="btn btn-sm btn-link text-primary text-decoration-none p-0 mt-1" 
                            onclick="addOption('${questionId}')">
                        <i class="bi bi-plus-lg me-1"></i>Add Option
                    </button>
                </div>
                ` : ''}
            </div>
            
            <div class="d-flex justify-content-between align-items-center pt-2 border-top border-light mt-2">
                <div class="form-check form-switch form-switch-sm m-0">
                    <input class="form-check-input shadow-none question-required-check" 
                           type="checkbox" 
                           data-question-id="${questionId}"
                           id="required_${questionId}"
                           ${isRequired ? 'checked' : ''}
                           onchange="saveCustomQuestions()">
                    <label class="form-check-label small text-muted" for="required_${questionId}">
                        Required
                    </label>
                </div>
                <div class="text-muted small cursor-move" title="Drag to reorder">
                     <i class="bi bi-grip-vertical"></i> 
                </div>
            </div>
        </div>
    `;
    
    container.insertAdjacentHTML('beforeend', questionHTML);
    updateCustomQuestionCount();
    saveCustomQuestions();
}

// Remove custom question
window.removeCustomQuestion = function(questionId) {
    const questionElement = document.querySelector(`[data-question-id="${questionId}"]`);
    if (questionElement) {
        questionElement.style.opacity = '0';
        questionElement.style.transform = 'translateX(-20px)';
        setTimeout(() => {
            questionElement.remove();
            renumberQuestions();
            updateCustomQuestionCount();
            saveCustomQuestions();
        }, 300);
    }
}

// Handle question type change
window.handleQuestionTypeChange = function(selectElement) {
    const questionId = selectElement.dataset.questionId;
    const newType = selectElement.value;
    const questionItem = selectElement.closest('.custom-question-item');
    
    // Remove existing options section if present
    const existingOptions = questionItem.querySelector('.question-options');
    if (existingOptions) {
        existingOptions.remove();
    }
    
    // Add options section for choice types
    if (newType === 'single' || newType === 'multiple') {
        const optionsHTML = `
            <div class="question-options ps-3 border-start border-2 border-light mb-3">
                <label class="form-label small text-muted text-uppercase fw-bold" style="font-size:0.7rem; letter-spacing: 0.5px;">Options</label>
                <div class="options-list" data-question-id="${questionId}">
                    <div class="option-item mb-2">
                        <div class="input-group input-group-sm">
                            <input type="text" class="form-control bg-light border-0 rounded-1 option-input" 
                                   placeholder="Option 1" 
                                   onchange="saveCustomQuestions()" required>
                            <button type="button" class="btn btn-link text-danger text-decoration-none border-0" 
                                    onclick="removeOption(this)">
                                <i class="bi bi-x-lg"></i>
                            </button>
                        </div>
                    </div>
                    <div class="option-item mb-2">
                        <div class="input-group input-group-sm">
                            <input type="text" class="form-control bg-light border-0 rounded-1 option-input" 
                                   placeholder="Option 2" 
                                   onchange="saveCustomQuestions()" required>
                            <button type="button" class="btn btn-link text-danger text-decoration-none border-0" 
                                    onclick="removeOption(this)">
                                <i class="bi bi-x-lg"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <button type="button" class="btn btn-sm btn-link text-primary text-decoration-none p-0 mt-1" 
                        onclick="addOption('${questionId}')">
                    <i class="bi bi-plus-lg me-1"></i>Add Option
                </button>
            </div>
        `;
        questionItem.querySelector('.question-body').insertAdjacentHTML('beforeend', optionsHTML);
    }
    
    saveCustomQuestions();
}

// Add option to a question
window.addOption = function(questionId) {
    const optionsList = document.querySelector(`.options-list[data-question-id="${questionId}"]`);
    if (!optionsList) return;
    
    const optionCount = optionsList.querySelectorAll('.option-item').length + 1;
    const optionHTML = `
        <div class="option-item mb-2">
            <div class="input-group input-group-sm">
                <input type="text" class="form-control bg-light border-0 rounded-1 option-input" 
                       placeholder="Option ${optionCount}" 
                       onchange="saveCustomQuestions()" required>
                <button type="button" class="btn btn-link text-danger text-decoration-none border-0" 
                        onclick="removeOption(this)">
                    <i class="bi bi-x-lg"></i>
                </button>
            </div>
        </div>
    `;
    optionsList.insertAdjacentHTML('beforeend', optionHTML);
}

// Remove option
window.removeOption = function(buttonElement) {
    const optionItem = buttonElement.closest('.option-item');
    const optionsList = buttonElement.closest('.options-list');
    
    // Don't allow removing if only 2 options left
    if (optionsList.querySelectorAll('.option-item').length <= 2) {
        alert('You must have at least 2 options');
        return;
    }
    
    optionItem.style.opacity = '0';
    setTimeout(() => {
        optionItem.remove();
        saveCustomQuestions();
    }, 200);
}

// Renumber questions
function renumberQuestions() {
    const questions = document.querySelectorAll('.custom-question-item');
    questions.forEach((question, index) => {
        const number = index + 1;
        const numberEl = question.querySelector('.question-number');
        const labelEl = question.querySelector('.question-header .text-muted');
        if (numberEl) numberEl.textContent = number;
        if (labelEl) labelEl.textContent = `Question ${number}`;
    });
    customQuestionCounter = questions.length;
}

// Save custom questions
window.saveCustomQuestions = function() {
    const questions = [];
    const questionItems = document.querySelectorAll('.custom-question-item');
    
    questionItems.forEach((item, index) => {
        const questionId = item.dataset.questionId;
        const typeSelect = item.querySelector('.question-type-select');
        const textInput = item.querySelector('.question-text-input');
        const requiredCheck = item.querySelector('.question-required-check');
        const optionInputs = item.querySelectorAll('.option-input');
        
        const questionText = textInput?.value?.trim() || '';
        const questionType = typeSelect?.value || 'text';
        
        // Validate: Skip if question text is empty
        if (!questionText) {
            return; // Skip this question
        }
        
        // For choice-type questions, validate options
        const choiceTypes = ['single', 'multiple', 'yesno'];
        let validOptions = [];
        
        if (choiceTypes.includes(questionType)) {
            if (questionType === 'yesno') {
                // Yes/No has fixed options and no editable option inputs in UI.
                validOptions = ['Yes', 'No'];
            } else {
                validOptions = Array.from(optionInputs)
                    .map(input => input.value.trim())
                    .filter(val => val !== '');

                // Skip if choice-type question has no valid options
                if (validOptions.length === 0) {
                    return; // Skip this question
                }
            }
        }
        
        const questionData = {
            id: questionId,
            order: index + 1, // Preserve order for repopulation
            type: questionType,
            question: questionText,
            required: requiredCheck?.checked || false,
            options: choiceTypes.includes(questionType) ? validOptions : []
        };
        
        questions.push(questionData);
    });
    
    // Save just the custom questions first
    if (window.formDataStorage && typeof window.formDataStorage.saveFormData === 'function') {
        window.formDataStorage.saveFormData({ custom_rsvp_questions: questions });
    }
    
    // Debounce the full RSVP form data save to avoid too many calls
    if (window.saveCustomQuestionsTimeout) {
        clearTimeout(window.saveCustomQuestionsTimeout);
    }
    window.saveCustomQuestionsTimeout = setTimeout(() => {
        if (typeof window.saveRSVPFormData === 'function') {
            window.saveRSVPFormData();
        }
    }, 500);
}

// Load custom questions
function loadCustomQuestions() {
    if (!window.formDataStorage || typeof window.formDataStorage.getStoredData !== 'function') return;
    
    const storedData = window.formDataStorage.getStoredData();
    const savedQuestions = storedData.custom_rsvp_questions;
    
    if (savedQuestions && Array.isArray(savedQuestions)) {
        savedQuestions.forEach(questionData => {
            addCustomQuestion(questionData);
        });
        updateCustomQuestionCount();
    }
}

// Load RSVP form data from storage
window.loadRSVPFormData = function loadRSVPFormData() {
    if (!window.formDataStorage || typeof window.formDataStorage.getStoredData !== 'function') return;
    
    const storedData = window.formDataStorage.getStoredData();
    const rsvpForm = document.querySelector('[data-model="rsvp-tab"] .edit-form');
    
    if (!rsvpForm || !storedData) return;
    
    // Load all form fields with data-theme-key
    const elementsWithThemeKey = rsvpForm.querySelectorAll('[data-theme-key]');
    
    elementsWithThemeKey.forEach(element => {
        const themeKey = element.getAttribute('data-theme-key');
        if (!themeKey) return;
        
        // Get value from stored data (handle nested keys)
        let value = storedData[themeKey];
        
        if (themeKey.includes('.')) {
            const keys = themeKey.split('.');
            value = keys.reduce((obj, key) => obj?.[key], storedData);
        }
        
        if (value === undefined || value === null) return;
        
        // Set value based on input type
        if (element.type === 'checkbox') {
            element.checked = !!value;
        } else if (element.type === 'radio') {
            if (element.value === value) {
                element.checked = true;
            }
        } else if (element.tagName === 'SELECT') {
            element.value = value;
        } else if (element.tagName === 'TEXTAREA') {
            element.value = value;
        } else {
            element.value = value;
        }
    });
    
    // Load guest count
    loadGuestCountData();
    
    // Load custom questions
    loadCustomQuestions();
}

// Attach change listeners to all RSVP form fields
window.attachRSVPFormListeners = function attachRSVPFormListeners() {
    const rsvpContainer = document.getElementById('rsvpContainer');
    if (!rsvpContainer) return;
    
    // Get all inputs with data-theme-key
    const formInputs = rsvpContainer.querySelectorAll('[data-theme-key]');
    
    formInputs.forEach(input => {
        // Remove existing listeners to avoid duplicates
        const newInput = input.cloneNode(true);
        input.parentNode.replaceChild(newInput, input);
        
        // Add appropriate listener based on input type
        if (newInput.type === 'checkbox' || newInput.type === 'radio') {
            newInput.addEventListener('change', function() {
                if (typeof window.saveRSVPFormData === 'function') {
                    window.saveRSVPFormData();
                }
            });
        } else if (newInput.tagName === 'TEXTAREA' || newInput.tagName === 'INPUT') {
            newInput.addEventListener('change', function() {
                if (typeof window.saveRSVPFormData === 'function') {
                    window.saveRSVPFormData();
                }
            });
            newInput.addEventListener('blur', function() {
                if (typeof window.saveRSVPFormData === 'function') {
                    window.saveRSVPFormData();
                }
            });
        } else if (newInput.tagName === 'SELECT') {
            newInput.addEventListener('change', function() {
                if (typeof window.saveRSVPFormData === 'function') {
                    window.saveRSVPFormData();
                }
            });
        }
    });
}

// Save all RSVP form data
window.saveRSVPFormData = function saveRSVPFormData() {
    if (!window.formDataStorage || typeof window.formDataStorage.saveFormData !== 'function') {
        console.warn('Form data storage not available');
        return null;
    }
    
    const rsvpForm = document.querySelector('[data-model="rsvp-tab"] .edit-form');
    if (!rsvpForm) {
        console.warn('RSVP form not found');
        return null;
    }
    
    // Extract form data using the helper function
    const formData = extractFormDataWithThemeKeys(rsvpForm);
    
    // Also save custom questions
    const questions = [];
    const questionItems = document.querySelectorAll('.custom-question-item');
    
    questionItems.forEach(item => {
        const questionId = item.dataset.questionId;
        const typeSelect = item.querySelector('.question-type-select');
        const textInput = item.querySelector('.question-text-input');
        const requiredCheck = item.querySelector('.question-required-check');
        const optionInputs = item.querySelectorAll('.option-input');
        
        const questionType = typeSelect?.value || 'text';
        const questionData = {
            id: questionId,
            type: questionType,
            question: textInput?.value || '',
            required: requiredCheck?.checked || false,
            options: questionType === 'yesno'
                ? ['Yes', 'No']
                : Array.from(optionInputs).map(input => input.value).filter(val => val.trim())
        };
        
        questions.push(questionData);
    });
    
    if (questions.length > 0) {
        formData.custom_rsvp_questions = questions;
    }
    
    // Save to storage
    // console.log('Saving RSVP form data:', formData);
    window.formDataStorage.saveFormData(formData);
    
    return formData;
}

// Helper function to extract form data
function extractFormDataWithThemeKeys(form) {
    const formData = {};
    
    const elementsWithThemeKey = form.querySelectorAll('[data-theme-key]');
    
    elementsWithThemeKey.forEach(element => {
        const themeKey = element.getAttribute('data-theme-key');
        
        if (!themeKey) return;
        
        let value = null;
        
        if (element.type === 'checkbox') {
            value = element.checked;
        } else if (element.type === 'radio') {
            if (element.checked) {
                value = element.value;
            } else {
                return;
            }
        } else if (element.tagName === 'SELECT') {
            if (element.multiple) {
                value = Array.from(element.selectedOptions).map(option => option.value);
            } else {
                value = element.value;
            }
        } else if (element.tagName === 'TEXTAREA') {
            value = element.value;
        } else {
            value = element.value;
        }
        
        if (themeKey.includes('.')) {
            const keys = themeKey.split('.');
            let current = formData;
            
            for (let i = 0; i < keys.length - 1; i++) {
                if (!current[keys[i]]) {
                    current[keys[i]] = {};
                }
                current = current[keys[i]];
            }
            
            current[keys[keys.length - 1]] = value;
        } else {
            formData[themeKey] = value;
        }
    });
    
    return formData;
}

// Initialize guest count controls
window.initializeGuestCountControls = function initializeGuestCountControls() {
    const decreaseBtn = document.getElementById('decreaseGuestCount');
    const increaseBtn = document.getElementById('increaseGuestCount');
    const guestCountInput = document.getElementById('rsvpGuestCount');
    
    if (!decreaseBtn || !increaseBtn || !guestCountInput) return;
    
    // Remove existing event listeners to prevent duplicates
    decreaseBtn.replaceWith(decreaseBtn.cloneNode(true));
    increaseBtn.replaceWith(increaseBtn.cloneNode(true));
    
    // Get fresh references after cloning
    const newDecreaseBtn = document.getElementById('decreaseGuestCount');
    const newIncreaseBtn = document.getElementById('increaseGuestCount');
    const newGuestCountInput = document.getElementById('rsvpGuestCount');
    
    // Add decrease functionality
    newDecreaseBtn.addEventListener('click', function() {
        let currentValue = parseInt(newGuestCountInput.value, 10);
        const minValue = parseInt(newGuestCountInput.getAttribute('min'), 10) || 10;
        const step = parseInt(newGuestCountInput.getAttribute('step'), 10) || 5;
        
        if (currentValue > minValue) {
            const newValue = Math.max(minValue, currentValue - step);
            updateGuestCountValue(newValue, newGuestCountInput);
            
            // Add visual feedback
            newDecreaseBtn.classList.add('btn-pressed');
            setTimeout(() => newDecreaseBtn.classList.remove('btn-pressed'), 150);
            
            saveGuestCountData();
        }
        
        // Update button states
        updateGuestCountButtonStates();
    });
    
    // Add increase functionality
    newIncreaseBtn.addEventListener('click', function() {
        let currentValue = parseInt(newGuestCountInput.value, 10);
        const step = parseInt(newGuestCountInput.getAttribute('step'), 10) || 5;
        const maxValue = parseInt(newGuestCountInput.getAttribute('max'), 10) || 500; // Set reasonable max
        
        if (currentValue < maxValue) {
            const newValue = Math.min(maxValue, currentValue + step);
            updateGuestCountValue(newValue, newGuestCountInput);
            
            // Add visual feedback
            newIncreaseBtn.classList.add('btn-pressed');
            setTimeout(() => newIncreaseBtn.classList.remove('btn-pressed'), 150);
            
            saveGuestCountData();
        }
        
        // Update button states
        updateGuestCountButtonStates();
    });
    
    // Initialize button states
    updateGuestCountButtonStates();
    
    // Load saved guest count
    loadGuestCountData();
    
    // Add input change listener to save data
    newGuestCountInput.addEventListener('input', function() {
        saveGuestCountData();
    });
    
    newGuestCountInput.addEventListener('change', function() {
        saveGuestCountData();
        updateGuestCountButtonStates();
    });
    
    // Add keyboard support for accessibility
    newGuestCountInput.addEventListener('keydown', function(e) {
        const step = parseInt(this.getAttribute('step'), 10) || 5;
        const minValue = parseInt(this.getAttribute('min'), 10) || 10;
        const maxValue = parseInt(this.getAttribute('max'), 10) || 500;
        let currentValue = parseInt(this.value, 10);
        
        if (e.key === 'ArrowUp' || e.key === 'Plus') {
            e.preventDefault();
            if (currentValue < maxValue) {
                const newValue = Math.min(maxValue, currentValue + step);
                updateGuestCountValue(newValue, this);
                saveGuestCountData();
                updateGuestCountButtonStates();
            }
        } else if (e.key === 'ArrowDown' || e.key === 'Minus') {
            e.preventDefault();
            if (currentValue > minValue) {
                const newValue = Math.max(minValue, currentValue - step);
                updateGuestCountValue(newValue, this);
                saveGuestCountData();
                updateGuestCountButtonStates();
            }
        }
    });
}

// Update guest count value with animation
function updateGuestCountValue(newValue, inputElement) {
    if (!inputElement) return;
    
    // Set the new value
    inputElement.value = newValue;
    
    // Add animation class
    inputElement.classList.add('value-changed');
    
    // Remove animation class after animation completes
    setTimeout(() => {
        inputElement.classList.remove('value-changed');
    }, 600);
    
    // Trigger change event
    inputElement.dispatchEvent(new Event('change'));
}

// Update button states based on current value
function updateGuestCountButtonStates() {
    const decreaseBtn = document.getElementById('decreaseGuestCount');
    const increaseBtn = document.getElementById('increaseGuestCount');
    const guestCountInput = document.getElementById('rsvpGuestCount');
    
    if (!decreaseBtn || !increaseBtn || !guestCountInput) return;
    
    const currentValue = parseInt(guestCountInput.value, 10);
    const minValue = parseInt(guestCountInput.getAttribute('min'), 10) || 10;
    const maxValue = parseInt(guestCountInput.getAttribute('max'), 10) || 500;
    
    // Disable/enable decrease button
    if (currentValue <= minValue) {
        decreaseBtn.disabled = true;
        decreaseBtn.classList.add('disabled');
    } else {
        decreaseBtn.disabled = false;
        decreaseBtn.classList.remove('disabled');
    }
    
    // Disable/enable increase button
    if (currentValue >= maxValue) {
        increaseBtn.disabled = true;
        increaseBtn.classList.add('disabled');
    } else {
        increaseBtn.disabled = false;
        increaseBtn.classList.remove('disabled');
    }
}

// Save guest count data
function saveGuestCountData() {
    const guestCountInput = document.getElementById('rsvpGuestCount');
    if (!guestCountInput) return;
    
    const guestCount = guestCountInput.value;
    
    // Update form data if form data storage is available
    if (window.formDataStorage && typeof window.formDataStorage.saveFormData === 'function') {
        window.formDataStorage.saveFormData({ expected_guests: guestCount });
    }
}

// Load guest count data
function loadGuestCountData() {
    const guestCountInput = document.getElementById('rsvpGuestCount');
    if (!guestCountInput) return;
    
    // Load from formDataStorage if available
    if (window.formDataStorage && typeof window.formDataStorage.getStoredData === 'function') {
        const storedData = window.formDataStorage.getStoredData();
        const savedGuestCount = storedData.expected_guests;
        
        if (savedGuestCount && !isNaN(parseInt(savedGuestCount, 10))) {
            const value = parseInt(savedGuestCount, 10);
            const minValue = parseInt(guestCountInput.getAttribute('min'), 10) || 10;
            const maxValue = parseInt(guestCountInput.getAttribute('max'), 10) || 500;
            
            // Ensure value is within bounds
            if (value >= minValue && value <= maxValue) {
                guestCountInput.value = value;
            }
        }
    }
    
    // Update button states after loading
    updateGuestCountButtonStates();
}

// Ensure the default attendance question exists
function ensureDefaultQuestion() {
    const container = document.getElementById('rsvpQuestionsContainer');
    if (!container) return;
    
    // Check if default question already exists
    const existingDefault = container.querySelector('[data-question-id="attendance"]');
    if (existingDefault) return;
    
    // Add default attendance question if it doesn't exist
    const defaultQuestion = {
        id: 'attendance',
        type: 'single',
        title: 'Will you be joining us for the event?',
        required: true,
        options: ['Yes, I\'ll be there', 'No, can\'t make it', 'Maybe']
    };
    
    const questionHtml = createQuestionHTML(defaultQuestion);
    container.insertAdjacentHTML('afterbegin', questionHtml);
    container.classList.add('has-questions');
}

window.initializeSortable = initializeSortable;
function initializeSortable() {
    const container = document.getElementById('rsvpQuestionsContainer');
    if (container && !container.hasAttribute('data-sortable-initialized')) {
        container.setAttribute('data-sortable-initialized', 'true');
    }
}

window.addRSVPQuestion = addRSVPQuestion;
function addRSVPQuestion(type) {
    const container = document.getElementById('rsvpQuestionsContainer');
    if (!container) return;

    // Ensure default question exists
    ensureDefaultQuestion();

    rsvpQuestionCounter++;
    const questionId = `question_${rsvpQuestionCounter}`;
    
    const questionData = {
        id: questionId,
        type: type,
        title: getDefaultQuestionTitle(type),
        required: false,
        options: getDefaultOptions(type)
    };

    rsvpQuestions.push(questionData);
    syncRSVPQuestions(); // Sync with global array

    const questionHtml = createQuestionHTML(questionData);
    container.insertAdjacentHTML('beforeend', questionHtml);
    
    // Update container class
    container.classList.add('has-questions');
    
    // Update preview
    updateRSVPPreview();
    
    // Save to storage
    // if (window.formDataStorage) {
    //     const rsvpData = window.formDataStorage.extractRSVPData();
    //     window.formDataStorage.saveFormData({ rsvpQuestions: rsvpData });
    // }
}

function getDefaultQuestionTitle(type) {
    const titles = {
        text: 'What is your name?',
        textarea: 'Any additional comments?',
        single: 'Please select one option:',
        multiple: 'Select all that apply:',
        yesno: 'Do you have any dietary restrictions?',
        rating: 'How excited are you for this event?'
    };
    return titles[type] || 'New Question';
}

window.getDefaultOptions = getDefaultOptions;
function getDefaultOptions(type) {
    const options = {
        single: ['Option 1', 'Option 2', 'Option 3'],
        multiple: ['Option 1', 'Option 2', 'Option 3'],
        yesno: ['Yes', 'No'],
        rating: [] // Rating doesn't need options
    };
    return options[type] || [];
}

window.createQuestionHTML = createQuestionHTML;
function createQuestionHTML(questionData) {
    const typeIcons = {
        text: 'bi-type',
        textarea: 'bi-textarea-t',
        single: 'bi-record-circle',
        multiple: 'bi-check2-square',
        yesno: 'bi-toggle-on',
        rating: 'bi-star'
    };

    const typeBadges = {
        text: 'Text Input',
        textarea: 'Long Text',
        single: 'Single Choice',
        multiple: 'Multiple Choice',
        yesno: 'Yes/No',
        rating: 'Rating'
    };

    let optionsHTML = '';
    if (questionData.options && questionData.options.length > 0 && 
        questionData.type !== 'rating' && questionData.type !== 'text' && questionData.type !== 'textarea') {
        optionsHTML = `
            <div class="question-options mt-3">
                ${questionData.options.map((option, index) => `
                    <div class="option-item mb-2">
                        <div class="input-group input-group-sm">
                            <span class="input-group-text bg-transparent border-0 ps-0">
                                <i class="${questionData.type === 'multiple' ? 'bi-check2-square' : 'bi-record-circle'} text-muted"></i>
                            </span>
                            <input type="text" class="form-control form-control-sm bg-light border-0 rounded-1 option-text" value="${option}" 
                                   onchange="updateQuestionOption('${questionData.id}', ${index}, this.value)" placeholder="Option ${index + 1}">
                            ${questionData.options.length > 2 ? `
                                <button type="button" class="btn btn-link text-danger text-decoration-none btn-sm btn-remove-option" 
                                        onclick="removeQuestionOption('${questionData.id}', ${index})">
                                    <i class="bi bi-x-lg"></i>
                                </button>
                            ` : ''}
                        </div>
                    </div>
                `).join('')}
                <button type="button" class="btn btn-sm btn-link text-decoration-none p-0 mt-1" 
                        onclick="addQuestionOption('${questionData.id}'); return false;">
                    <i class="bi bi-plus-lg me-1"></i>Add Option
                </button>
            </div>
        `;
    }

    return `
        <div class="question-item minimal-card p-3 mb-3 bg-white rounded-3 shadow-sm border-0" data-question-id="${questionData.id}">
            <div class="d-flex justify-content-between align-items-start">
                <div class="flex-grow-1">
                    <input type="text" class="form-control form-control-flush fw-bold p-0 text-dark mb-1" 
                           value="${questionData.title}" 
                           placeholder="Type your question"
                           onchange="updateQuestionTitle('${questionData.id}', this.value)">
                    <div class="d-flex align-items-center">
                        <span class="badge bg-light text-secondary border fw-normal">
                             <i class="${typeIcons[questionData.type]} me-1"></i>${typeBadges[questionData.type]}
                        </span>
                    </div>
                </div>
                <button type="button" class="btn btn-sm btn-link text-danger border-0 p-0 ms-2" 
                        onclick="removeRSVPQuestion('${questionData.id}')" title="Delete Question">
                    <i class="bi bi-trash"></i>
                </button>
            </div>
            
            ${optionsHTML}
            
            <div class="d-flex justify-content-between align-items-center mt-3 pt-3 border-top border-light">
                <div class="form-check form-switch form-switch-sm m-0">
                    <input class="form-check-input" type="checkbox" id="required_${questionData.id}" 
                           ${questionData.required ? 'checked' : ''} 
                           onchange="updateQuestionRequired('${questionData.id}', this.checked)">
                    <label class="form-check-label small text-muted" for="required_${questionData.id}">Required</label>
                </div>
                <div class="text-black-50 cursor-move" title="Drag to reorder">
                    <i class="bi bi-grip-vertical"></i>
                </div>
            </div>
        </div>
    `;
}

window.updateQuestionTitle = updateQuestionTitle;
function updateQuestionTitle(questionId, title) {
    const question = rsvpQuestions.find(q => q.id === questionId);
    if (question) {
        question.title = title;
        updateRSVPPreview();
    }
}

window.updateQuestionRequired = updateQuestionRequired;
function updateQuestionRequired(questionId, required) {
    const question = rsvpQuestions.find(q => q.id === questionId);
    if (question) {
        question.required = required;
        updateRSVPPreview();
    }
}

window.updateQuestionOption = updateQuestionOption;
function updateQuestionOption(questionId, optionIndex, value) {
    const question = rsvpQuestions.find(q => q.id === questionId);
    if (question && question.options) {
        question.options[optionIndex] = value;
        updateRSVPPreview();
    }
}

window.addQuestionOption = addQuestionOption;
function addQuestionOption(questionId) {
    const question = rsvpQuestions.find(q => q.id === questionId);
    if (question && question.options) {
        question.options.push(`Option ${question.options.length + 1}`);
        
        // Refresh the question HTML
        const questionElement = document.querySelector(`[data-question-id="${questionId}"]`);
        const newQuestionHTML = createQuestionHTML(question);
        questionElement.outerHTML = newQuestionHTML;
        
        updateRSVPPreview();
    }
}

window.removeQuestionOption = removeQuestionOption;
function removeQuestionOption(questionId, optionIndex) {
    const question = rsvpQuestions.find(q => q.id === questionId);
    if (question && question.options && question.options.length > 2) {
        question.options.splice(optionIndex, 1);
        
        // Refresh the question HTML
        const questionElement = document.querySelector(`[data-question-id="${questionId}"]`);
        const newQuestionHTML = createQuestionHTML(question);
        questionElement.outerHTML = newQuestionHTML;
        
        updateRSVPPreview();
    }
}

window.removeRSVPQuestion = removeRSVPQuestion;
function removeRSVPQuestion(questionId) {
    // Don't remove the default attendance question
    if (questionId === 'attendance') return;
    
    const questionIndex = rsvpQuestions.findIndex(q => q.id === questionId);
    if (questionIndex !== -1) {
        rsvpQuestions.splice(questionIndex, 1);
    }
    
    const questionElement = document.querySelector(`[data-question-id="${questionId}"]`);
    if (questionElement) {
        questionElement.remove();
    }
    
    // Update container class
    const container = document.getElementById('rsvpQuestionsContainer');
    if (container && container.children.length <= 1) {
        container.classList.remove('has-questions');
    }
    
    updateRSVPPreview();
}

// Move question up or down
window.moveQuestion = moveQuestion;
function moveQuestion(questionId, direction) {
    const container = document.getElementById('rsvpQuestionsContainer');
    if (!container) return;
    
    const questionElement = container.querySelector(`[data-question-id="${questionId}"]`);
    if (!questionElement) return;
    
    // Add moving animation
    questionElement.classList.add('moving');
    
    setTimeout(() => {
        if (direction === 'up') {
            const previousElement = questionElement.previousElementSibling;
            if (previousElement && previousElement.classList.contains('question-item')) {
                container.insertBefore(questionElement, previousElement);
                updateQuestionOrder();
            }
        } else if (direction === 'down') {
            const nextElement = questionElement.nextElementSibling;
            if (nextElement && nextElement.classList.contains('question-item')) {
                container.insertBefore(nextElement, questionElement);
                updateQuestionOrder();
            }
        }
        
        // Remove moving animation
        setTimeout(() => {
            questionElement.classList.remove('moving');
        }, 100);
    }, 150);
}

// Update the question order in the rsvpQuestions array
function updateQuestionOrder() {
    const container = document.getElementById('rsvpQuestionsContainer');
    if (!container) return;
    
    const questionItems = Array.from(container.querySelectorAll('.question-item'));
    const newOrder = [];
    
    questionItems.forEach(item => {
        const questionId = item.getAttribute('data-question-id');
        // Skip the default attendance question - it's not in rsvpQuestions array
        if (questionId !== 'attendance') {
            const question = rsvpQuestions.find(q => q.id === questionId);
            if (question) {
                newOrder.push(question);
            }
        }
    });
    
    // Update the rsvpQuestions array (only custom questions)
    rsvpQuestions.length = 0;
    rsvpQuestions.push(...newOrder);
    syncRSVPQuestions();
    
    // Update preview and save
    updateRSVPPreview();
    if (window.saveRSVPData) {
        window.saveRSVPData();
    }
}

window.toggleRSVPPreview = toggleRSVPPreview;
function toggleRSVPPreview() {
    const preview = document.getElementById('rsvpFormPreview');
    if (preview) {
        if (preview.style.display === 'none') {
            preview.style.display = 'block';
            updateRSVPPreview();
        } else {
            preview.style.display = 'none';
        }
    }
}

window.updateRSVPPreview = updateRSVPPreview;
function updateRSVPPreview() {
    const previewContent = document.getElementById('rsvpPreviewContent');
    if (!previewContent) return;

    let previewHTML = '';
    
    // Get all questions from the container in their current order
    const container = document.getElementById('rsvpQuestionsContainer');
    if (container) {
        const questionItems = container.querySelectorAll('.question-item');
        questionItems.forEach(item => {
            const questionId = item.getAttribute('data-question-id');
            
            if (questionId === 'attendance') {
                // Default attendance question
                previewHTML += createPreviewQuestion({
                    id: 'attendance',
                    title: 'Will you be joining us for the event?',
                    type: 'single',
                    required: true,
                    options: ['Yes, I\'ll be there', 'No, can\'t make it', 'Maybe']
                });
            } else {
                // Custom questions
                const question = rsvpQuestions.find(q => q.id === questionId);
                if (question) {
                    previewHTML += createPreviewQuestion(question);
                }
            }
        });
    }

    previewContent.innerHTML = previewHTML || '<p class="text-muted">No questions added yet.</p>';
}

window.createPreviewQuestion = createPreviewQuestion;
function createPreviewQuestion(question) {
    let inputHTML = '';
    
    switch (question.type) {
        case 'text':
            inputHTML = `<input type="text" class="form-control shadow-none" placeholder="Your answer">`;
            break;
        case 'textarea':
            inputHTML = `<textarea class="form-control shadow-none" rows="3" placeholder="Your answer"></textarea>`;
            break;
        case 'single':
            inputHTML = question.options.map((option, index) => `
                <div class="form-check">
                    <input class="form-check-input shadow-none" type="radio" name="preview_${question.id}" value="${option}" id="preview_${question.id}_${index}">
                    <label class="form-check-label" for="preview_${question.id}_${index}">${option}</label>
                </div>
            `).join('');
            break;
        case 'multiple':
            inputHTML = question.options.map((option, index) => `
                <div class="form-check">
                    <input class="form-check-input shadow-none" type="checkbox" value="${option}" id="preview_${question.id}_${index}">
                    <label class="form-check-label" for="preview_${question.id}_${index}">${option}</label>
                </div>
            `).join('');
            break;
        case 'yesno':
            inputHTML = `
                <div class="form-check form-check-inline">
                    <input class="form-check-input shadow-none" type="radio" name="preview_${question.id}" value="yes" id="preview_${question.id}_yes">
                    <label class="form-check-label" for="preview_${question.id}_yes">Yes</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input shadow-none" type="radio" name="preview_${question.id}" value="no" id="preview_${question.id}_no">
                    <label class="form-check-label" for="preview_${question.id}_no">No</label>
                </div>
            `;
            break;
        case 'rating':
            inputHTML = `
                <div class="rating-stars" data-question-id="${question.id}">
                    ${[1,2,3,4,5].map(i => `<span class="star" data-rating="${i}" onclick="setRating('${question.id}', ${i})">★</span>`).join('')}
                </div>
            `;
            break;
    }

    return `
        <div class="preview-question">
            <div class="preview-question-title">
                ${question.title}
                ${question.required ? '<span class="preview-question-required">*</span>' : ''}
            </div>
            ${inputHTML}
        </div>
    `;
}

// Rating functionality for preview
window.setRating = setRating;
function setRating(questionId, rating) {
    const ratingContainer = document.querySelector(`[data-question-id="${questionId}"]`);
    if (ratingContainer) {
        const stars = ratingContainer.querySelectorAll('.star');
        stars.forEach((star, index) => {
            if (index < rating) {
                star.classList.add('selected');
            } else {
                star.classList.remove('selected');
            }
        });
        
        // Store the rating value
        ratingContainer.setAttribute('data-rating', rating);
    }
}

// Save RSVP data to localStorage
function saveRSVPData() {
    if (window.formDataStorage) {
        window.formDataStorage.saveRSVPData({
            questions: rsvpQuestions,
            questionCounter: rsvpQuestionCounter,
            settings: {
                // Add any RSVP settings here
            }
        });
    }
}

// Load saved RSVP data from localStorage
function loadSavedRSVPData() {
    if (window.formDataStorage) {
        const savedData = window.formDataStorage.loadRSVPData();
        
        if (savedData.questions && savedData.questions.length > 0) {
            rsvpQuestions = savedData.questions;
            rsvpQuestionCounter = savedData.questionCounter || rsvpQuestions.length + 1;
            
            // Rebuild the RSVP form from saved data
            rebuildRSVPForm();
        }
    }
}

// Rebuild RSVP form from saved data
function rebuildRSVPForm() {
    const container = document.getElementById('rsvpQuestionsContainer');
    if (!container) return;
    
    // Clear existing questions
    container.innerHTML = '';
    
    // Add default attendance question first
    const defaultQuestion = {
        id: 'attendance',
        type: 'single',
        title: 'Will you be joining us for the event?',
        required: true,
        options: ['Yes, I\'ll be there', 'No, can\'t make it', 'Maybe']
    };
    const defaultQuestionHtml = createQuestionHTML(defaultQuestion);
    container.insertAdjacentHTML('beforeend', defaultQuestionHtml);
    
    // Rebuild each custom question
    rsvpQuestions.forEach(questionData => {
        const questionHtml = createQuestionHTML(questionData);
        container.insertAdjacentHTML('beforeend', questionHtml);
    });
    
    // Update container class
    container.classList.add('has-questions');
    
    // Update preview
    updateRSVPPreview();
}

// Add save calls to existing functions
const originalUpdateQuestionTitle = window.updateQuestionTitle;
window.updateQuestionTitle = function(questionId, title) {
    originalUpdateQuestionTitle(questionId, title);
    saveRSVPData();
};

const originalUpdateQuestionRequired = window.updateQuestionRequired;
window.updateQuestionRequired = function(questionId, required) {
    originalUpdateQuestionRequired(questionId, required);
    saveRSVPData();
};

const originalUpdateQuestionOption = window.updateQuestionOption;
window.updateQuestionOption = function(questionId, optionIndex, value) {
    originalUpdateQuestionOption(questionId, optionIndex, value);
    saveRSVPData();
};

const originalAddQuestionOption = window.addQuestionOption;
window.addQuestionOption = function(questionId) {
    originalAddQuestionOption(questionId);
    saveRSVPData();
};

const originalRemoveQuestionOption = window.removeQuestionOption;
window.removeQuestionOption = function(questionId, optionIndex) {
    originalRemoveQuestionOption(questionId, optionIndex);
    saveRSVPData();
};

const originalRemoveRSVPQuestion = window.removeRSVPQuestion;
window.removeRSVPQuestion = function(questionId) {
    originalRemoveRSVPQuestion(questionId);
    saveRSVPData();
};

const originalAddRSVPQuestion = window.addRSVPQuestion;
window.addRSVPQuestion = function(type) {
    originalAddRSVPQuestion(type);
    saveRSVPData();
};

// Make save/load functions globally available
window.saveRSVPData = saveRSVPData;
window.loadSavedRSVPData = loadSavedRSVPData;
window.rebuildRSVPForm = rebuildRSVPForm;

